/**
 * Returns the `x-admin-tenant-id` header when a super admin is browsing a tenant's
 * organisation pages (not impersonating), so raw requests match axios requests.
 */
export const getAdminTenantContextHeaders = (): Record<string, string> => {
  try {
    const isImpersonating = Boolean(localStorage.getItem("authSnapshot"));
    const userRaw = localStorage.getItem("user");
    const userRole = userRaw ? (JSON.parse(userRaw)?.role as string | undefined) : undefined;
    const routeTenantId = window.location.pathname.match(/^\/admin\/tenants\/([^/]+)\/org(?:\/|$)/)?.[1];
    if (!isImpersonating && userRole === "super_admin" && routeTenantId) {
      return { "x-admin-tenant-id": routeTenantId };
    }
  } catch (error) {
    console.error("Failed to resolve admin tenant context:", error);
  }
  return {};
};

/**
 * Headers for antd `Upload` requests, which bypass the axios interceptor:
 * bearer token plus the admin tenant context when applicable.
 */
export const getUploadAuthHeaders = (): Record<string, string> => ({
  Authorization: `Bearer ${localStorage.getItem("token")}`,
  ...getAdminTenantContextHeaders(),
});
